const vsCartProgress = () => {
  let cart;
  fetch('/cart.js')
    .then((response) => response.json())
    .then((data) => {
      cart = data;
      vsPost('/apps/cart-progress/make_cart', cart)
        .then((response) => response.text())
        .then((data) => {
          const wrapper = document.getElementById('vs-cart-progress');
          wrapper.style.marginTop = '1em';
          wrapper.innerHTML = data;
          vsProgressChange(cart);
        })
    });

};

const vsProgressChange = (cart) => {
  const subtotal = cart.items_subtotal_price;
  const postData = {
    subtotal: subtotal,
  };
  let url = new URL(
    'https://thecheeselady.co.uk/apps/cart-progress/make_cart/progress'
  );
  url.search = new URLSearchParams(postData).toString();
  fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (parseFloat(data.width_pc) < 100) {
        document.querySelector('div.vs-progress-bar').style.display = 'block';
        document.querySelector('div.vs-progress-text').style.display = 'block';
        document.querySelector('div.vs-progress-text-free').style.display =
          'none';
        document.querySelector('span.vs-progress-bar-fill').style.width =
          data.width_pc + '%';
        document.querySelector('span.vs-to-go').innerHTML = data.to_go;
      } else {
        document.querySelector('div.vs-progress-bar').style.display = 'none';
        document.querySelector('div.vs-progress-text').style.display = 'none';
        document.querySelector('div.vs-progress-text-free').style.display =
          'block';
      }
    });
};

const vsPost = async (url = '', data = {}) => {
  return await fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      // 'X-Requested-With': 'XMLHttpRequest',
    },
    redirect: 'follow',
    body: JSON.stringify(data),
  });
};

const ajaxAddToCart = (evt) => {
  evt.preventDefault();
  const vid = evt.target.dataset.id;
  fetch('/cart/add.js', {
    method: 'POST',
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        {
          id: vid,
          quantity: 1,
        },
      ],
    }),
  }).then(() => {
    document.dispatchEvent(new CustomEvent('cart:build'));
  });
};

const initRecommendations = () => {
  const section = document.getElementById('cart-recommendations');
  const productId = section.dataset.productId;
  const limit = section.dataset.limit;
  const section_id = section.dataset.sectionType;
  const productRecommendationsSection = document.querySelector(
    '.product-recommendations'
  );
  fetch(
    `/recommendations/products?product_id=${productId}&limit=${limit}&section_id=${section_id}`
  )
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');
      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
        // theme.reinitProductGridItem(section);
        document.querySelectorAll('.recommended-add').forEach((el) => {
          el.addEventListener('click', (evt) => {
            ajaxAddToCart(evt);
          });
        });
      }
    });
};

document.addEventListener('DOMContentLoaded', () => {
  void vsCartProgress();
  initRecommendations();
  initFormListener();
});

document.addEventListener('cart:updated', (evt) => {
  void vsProgressChange(evt.detail.cart);
});

document.addEventListener('cart:build', async (evt) => {
  await fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      void vsProgressChange(cart);
    });
  initRecommendations();
});

const initFormListener = () => {
  const subYes = document.getElementById('allow-subs--yes');
  const subNo = document.getElementById('allow-subs--no');
  subYes.addEventListener('click', removeError);
  subNo.addEventListener('click', removeError);
};

const removeError = () => {
  document.querySelectorAll('.error-subs').forEach(el=>el.remove());
};

window.ZapietEvent?.listen('checkout_error', (e) => {
  if(e){
    document.querySelector('.cart__checkout').classList.remove('btn--loading');
  }
});
